import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "../WorkoutAdminModal.module.css";
import PresetPickerInline from "./PresetPickerInline";
import ExerciseSelectWithPreview from "./ExerciseSelectWithPreview";
import { formatRepsPerSet, formatRestPerSet, parseRepsPerSet, parseRestPerSet } from "./workoutAdminHelpers";

export default function PlanItemModal({
  planItemModalRef,
  closePlanItemModal,
  editingPlanItemId,
  categories,
  handlePlanCategoryChange,
  planCategoryItems,
  demoUrlFor,
  ownerId,
  previewExerciseDemo,
  planItemForm,
  setPlanItemForm,
  applyPreset,
  confirmDeletePreset,
  handleCreatePreset,
  handleSavePlanItem,
  newPresetForm,
  setNewPresetForm,
  presets,
  presetsLoading,
  saving,
  savingPreset,
  setShowCreatePresetForm,
  showCreatePresetForm,
}) {
  return (
    <div className={styles.innerOverlay} onClick={closePlanItemModal}>
                      <div
                        className={styles.planModal}
                        ref={planItemModalRef}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="wam-plan-item-title"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className={styles.planModalHeader}>
                          <div>
                            <h3 id="wam-plan-item-title">
                              {editingPlanItemId ? "Editar exercício do treino" : "Incluir exercício"}
                            </h3>
                            <p>
                              {editingPlanItemId
                                ? "Atualize os parâmetros deste exercício no treino."
                                : "Adicione um novo exercício ao treino selecionado."}
                            </p>
                          </div>

                          <button
                            type="button"
                            className={styles.planModalClose}
                            onClick={closePlanItemModal}
                            aria-label="Fechar modal"
                          >
                            <FontAwesomeIcon icon={faXmark} />
                          </button>
                        </div>

                        <form className={styles.wamForm} onSubmit={handleSavePlanItem}>
                          <div className={styles.wamField}>
                            <label>Categoria</label>
                            <select
                              value={planItemForm.exercise_id}
                              onChange={(e) => handlePlanCategoryChange(e.target.value)}
                              required
                            >
                              <option value="">Selecione</option>
                              {categories.map((cat) => (
                                <option key={cat.id} value={cat.id}>
                                  {cat.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className={styles.wamField}>
                            <label htmlFor="wam-plan-item-exercise">Exercício</label>
                            <ExerciseSelectWithPreview
                              id="wam-plan-item-exercise"
                              value={planItemForm.exercise_item_id}
                              onChange={(e) =>
                                setPlanItemForm((prev) => ({
                                  ...prev,
                                  exercise_item_id: e.target.value,
                                }))
                              }
                              items={planCategoryItems}
                              demoUrlFor={demoUrlFor}
                              onPreview={previewExerciseDemo}
                              ownerId={ownerId}
                            />
                          </div>

                          <PresetPickerInline
                            presets={presets}
                            loading={presetsLoading}
                            onApply={(preset) => applyPreset(preset, "plan")}
                            onDelete={confirmDeletePreset}
                            showCreateForm={showCreatePresetForm}
                            onToggleCreateForm={() => setShowCreatePresetForm((v) => !v)}
                            newPresetForm={newPresetForm}
                            onChangeNewPresetForm={setNewPresetForm}
                            onSubmitCreate={handleCreatePreset}
                            saving={savingPreset}
                          />

                          <div className={styles.setsRepsRow}>
                            <div className={styles.wamField} style={{width: 80, flexShrink: 0}}>
                              <label>Séries</label>
                              <input type="number" min={1} max={20} value={planItemForm.sets_planned}
                                onChange={(e) => { const n=Number(e.target.value)||0; setPlanItemForm((prev)=>({...prev, sets_planned:e.target.value, reps_per_set:parseRepsPerSet(prev.reps_planned,n), rest_per_set:parseRestPerSet(prev.rest_seconds,n)})); }} />
                            </div>
                            {planItemForm.sets_planned > 0 && (
                              <div className={styles.repsPerSetSection}>
                                <label className={styles.repsPerSetSectionLabel}>Repetições por série</label>
                                <div className={styles.repsPerSetRow}>
                                  {Array.from({ length: Number(planItemForm.sets_planned) }).map((_, i) => (
                                    <div key={i} className={styles.repsPerSetItem}>
                                      <span className={styles.repsPerSetLabel}>S{i+1}</span>
                                      <input type="text" className={styles.repsPerSetInput}
                                        value={planItemForm.reps_per_set[i] ?? ""} placeholder="-"
                                        onChange={(e) => { const arr=[...planItemForm.reps_per_set]; arr[i]=e.target.value; setPlanItemForm((prev)=>({...prev,reps_per_set:arr,reps_planned:formatRepsPerSet(arr)})); }} />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                            {planItemForm.sets_planned > 0 && (
                              <div className={styles.repsPerSetSection}>
                                <label className={styles.repsPerSetSectionLabel}>Descanso por série (s)</label>
                                <div className={styles.repsPerSetRow}>
                                  {Array.from({ length: Number(planItemForm.sets_planned) }).map((_, i) => (
                                    <div key={i} className={styles.repsPerSetItem}>
                                      <span className={styles.repsPerSetLabel}>S{i+1}</span>
                                      <input type="number" className={styles.repsPerSetInput}
                                        value={planItemForm.rest_per_set[i] ?? ""} placeholder="-"
                                        onChange={(e) => { const arr=[...planItemForm.rest_per_set]; arr[i]=e.target.value; setPlanItemForm((prev)=>({...prev,rest_per_set:arr,rest_seconds:formatRestPerSet(arr)})); }} />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>

                          <div className={styles.wamFormGrid3}>
                            <div className={styles.wamField}>
                              <label>Peso</label>
                              <input
                                type="number"
                                step="0.1"
                                value={planItemForm.weight_planned}
                                onChange={(e) =>
                                  setPlanItemForm((prev) => ({
                                    ...prev,
                                    weight_planned: e.target.value,
                                  }))
                                }
                              />
                            </div>

                            <div className={styles.wamField}>
                              <label>Duração</label>
                              <input
                                type="number"
                                value={planItemForm.duration_planned}
                                onChange={(e) =>
                                  setPlanItemForm((prev) => ({
                                    ...prev,
                                    duration_planned: e.target.value,
                                  }))
                                }
                              />
                            </div>

                            <div className={styles.wamField}>
                              <label>Descanso (s)</label>
                              <input
                                type="number"
                                value={planItemForm.sets_planned > 0 ? "" : planItemForm.rest_seconds}
                                placeholder={planItemForm.sets_planned > 0 ? "Ver por série ↑" : ""}
                                disabled={planItemForm.sets_planned > 0}
                                onChange={(e) => {
                                  const v = e.target.value;
                                  const n = Number(planItemForm.sets_planned) || 0;
                                  setPlanItemForm((prev) => ({
                                    ...prev,
                                    rest_seconds: v,
                                    rest_per_set: n > 0 ? parseRestPerSet(v, n) : [],
                                  }));
                                }}
                              />
                            </div>
                          </div>

                          <div className={styles.wamField}>
                            <label>Observações</label>
                            <textarea
                              rows="3"
                              value={planItemForm.notes}
                              onChange={(e) =>
                                setPlanItemForm((prev) => ({ ...prev, notes: e.target.value }))
                              }
                              placeholder="Orientações do professor"
                            />
                          </div>

                          <div className={styles.actionsRow}>
                            <button
                              type="button"
                              className={`${styles.wamBtn} ${styles.ghost}`}
                              onClick={closePlanItemModal}
                            >
                              Cancelar
                            </button>
                            <button
                              type="submit"
                              className={`${styles.wamBtn} ${styles.primary}`}
                              disabled={saving}
                            >
                              {editingPlanItemId ? "Salvar exercício" : "Incluir exercício"}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
  );
}
